import React from 'react'
import PropTypes from 'prop-types'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import googleDriveActions from 'redux/actions/googleDriveActions'
import errorCodes from 'helpers/enums/errorCodes'
import { localize } from 'helpers/translator'

const GoogleSlidesSavePresentationFailed = props => {
	let message = localize('googleSlides_savePresentationFailed')
	let title = null

	if (props.error.error_code === errorCodes.GOOGLE_SLIDES_INVALID_PERMISSIONS_ERROR) {
		message = localize('googleSlides_savePresentationPermissionFailed')
		title = localize('googleSlides_savePresentationPermissionFailed_title')
	}

	return (
		<Confirm
			btTwo={localize('global_ok')}
			alertTitle={title}
			alertMessage={message}
			actionButtonType={0}
			actionTwo={props.actions.close}
			closeAction={props.actions.close}
		/>
	)
}

GoogleSlidesSavePresentationFailed.propTypes = {
	actions: PropTypes.shape({
		close: PropTypes.func.isRequired,
	}).isRequired,
	error: PropTypes.object,
}

GoogleSlidesSavePresentationFailed.defaultProps = {
	error: {},
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		close: googleDriveActions.savePresentationFailedConfirmed,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GoogleSlidesSavePresentationFailed)

export { GoogleSlidesSavePresentationFailed }
